/* eslint-disable no-unused-vars */
import React from 'react'
import { Button, Divider, Space, Table, Tag } from 'antd'

const EmployeeForm = () => {
    return (
        <>
            <div>
                <Divider orientation="left" style={{
                    borderColor: '#fdb10e',
                }} >
                    <h2>Employee Form</h2>
                </Divider>



            </div>
        </>
    )
}

export default EmployeeForm
